import React from 'react';
import {
  Create, Datagrid, DisabledInput, Edit, EditButton, FunctionField, List, Responsive, SimpleForm, SimpleList, TextField,
  TextInput, BooleanInput
} from "admin-on-rest";

export const DevicesList = (props) => (
  <List {...props}>
    <Responsive
      small={
        <SimpleList
          primaryText={record => `${record.serialNumber}`}
          secondaryText={record => record.description}
        />
      }
      medium={
        <Datagrid bodyOptions={{ stripedRows: true, showRowHover: true }}>
          <TextField source="id" sortable={false} />
          <TextField source="serialNumber" label="Serial No." sortable={false} />
          <TextField source="macAddress" label="Mac Address" sortable={false} />
          <TextField source="activeStatus.title" label="Active Status" sortable={false} />
          <TextField source="presenceStatus.title" label="Presence Status" sortable={false}/>
          <TextField source="drynessStatus.title" label="Dryness Status" sortable={false} />
          <TextField source="description" label="Description" sortable={false} />
          <FunctionField render={record =>  record.owner ? `${record.owner.firstName} ${record.owner.lastName}` : '' }  label="Owner" sortable={false} />
          <EditButton />
        </Datagrid>
      }
    />
  </List>
);

const DeviceTitle = ({ record }) => {
  return <span>Device Serial No: {record ? `"${record.serialNumber}"` : ''}</span>;
};

export const DeviceEdit = (props) => (
  <Edit title={<DeviceTitle />} {...props}>
    <SimpleForm>
      <DisabledInput source="id" />
      <DisabledInput source="serialNumber" label="Serial No." />
      <DisabledInput source="macAddress" label="Mac Address" />
      <DisabledInput source="activeStatus.title" label="Active Status" />
      <DisabledInput source="presenceStatus.title" label="Presence Status" />
      <DisabledInput source="drynessStatus.title" label="Dryness Status" />
      <TextInput source="owner.username" label="Owner email" />
      <TextInput source="description" label="Description" />
      <BooleanInput source="deleteLogs" label="Delete logs?" />
    </SimpleForm>
  </Edit>
);

export const DeviceCreate = (props) => (
  <Create title="Add My Device" {...props}>
    <SimpleForm>
      <TextInput source="serialNumber" label="Serial No." />
    </SimpleForm>
  </Create>
);


// WEBPACK FOOTER //
// ./src/pages/devices/devices.js